import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const mainNewsSkeletons: TSkeletons = [
  { className: 'journal-main-news-preview journal-main-news-preview-link space-holder-right48-from-md', width: null, height: null },
]

export const additionalNewsSkeletons: TSkeletons = Array(4).fill({
  className: 'journal-short-news-simple-item space-holder32-from-md space-holder-top24-md',
})
